import i18n from "@/i18n";
import moment from "moment";

function parseGenesisMyHosts(): string[] {
  const raw = process.env.VUE_APP_GENESIS_MY_HOSTS || "";
  return raw
    .split(",")
    .map((h) => h.trim().toLowerCase())
    .filter(Boolean);
}

export function syncLocaleFromHost(): void {
  const allowlist = parseGenesisMyHosts();
  const normalizedHost = window.location.hostname.toLowerCase();
  const isGenesisMy = allowlist.includes(normalizedHost);
  const localeValue = isGenesisMy ? "en" : "id";

  i18n.global.locale.value = localeValue as any;
  sessionStorage.setItem("countryCode", localeValue);
  document.documentElement.setAttribute("data-locale", localeValue);

  moment.locale(localeValue);
}
